"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Link_1 = __importDefault(require("../Link"));
require("./PaginationLinks.scss");
var PaginationLinks = function (_a) {
    var links = _a.links;
    return (react_1.default.createElement("div", { className: "pagination" }, links.map(function (link, index) {
        return !link.url ? (react_1.default.createElement("div", { key: "pg-link-" + index, className: "pagination__item" }, link.label)) : (react_1.default.createElement(Link_1.default, { key: "pg-link-" + index, className: "pagination__link" + (link.active ? ' pagination__link--active' : ''), href: link.url }, link.label));
    })));
};
exports.default = PaginationLinks;
//# sourceMappingURL=PaginationLinks.js.map